import React, { useState } from "react";

const ToggleIcon = ({ defaultIcon, hoverIcon }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? hoverIcon : defaultIcon}
    </div>
  );
};

export default ToggleIcon;
